module.exports = __webpack_public_path__ + "fontawesome-webfont.a3de2170e4e9df77161e.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/fontawesome-webfont.ttf
// module id = ../../../../../src-admin/assets/fonts/fontawesome-webfont.ttf
// module chunks = styles